import React, {FC} from 'react';
import messages from '../messages';
import {actions as listingActions} from 'features/listing/list/slice';
import {tableSlice} from 'features/table/slice';
import {RotateCw, Trash2} from 'react-feather';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {Button} from 'reactstrap';
import {uiActions} from 'store/ui/ui-slice';
import {User} from 'types/user';

interface Props {
  user: User;
}

const TrashedUserActions: FC<Props> = ({user}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const handleRestore = () => {
    dispatch(
      uiActions.confirmRestore({
        name: 'trashed-users',
        resourceId: user.id,
        onRestore: () => {
          // Efface le marqueur "supprimé" dans le listing 'users' pour que
          // useAfterLife ne filtre plus cet utilisateur sur la liste active
          dispatch(
            listingActions.restoreResource({
              resourceName: 'users',
              resource: user,
            })
          );
          // Retire l'utilisateur de la vue corbeille et déclenche un refetch
          dispatch(
            tableSlice.actions.destroyResource({
              resourceId: user.id,
              resourceName: 'trashed-users',
            })
          );
        },
      })
    );
  };

  const handleForceDelete = () => {
    dispatch(
      uiActions.confirmDelete({
        name: 'trashed-users',
        resourceId: user.id,
      })
    );
  };

  return (
    <div className="d-flex align-items-center h-100">
      <Button
        className="me-2"
        color="transparent"
        title={t(...messages.restore())}
        onClick={handleRestore}
      >
        <RotateCw size={20} className="text-success" />
      </Button>
      <Button
        color="transparent"
        title={t(...messages.forceDelete())}
        onClick={handleForceDelete}
      >
        <Trash2 size={20} className="text-danger" />
      </Button>
    </div>
  );
};

export default TrashedUserActions;
